<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<wa-button [routerLink]="['/plugins']" appearance="plain" variant="neutral">Back to Plugins</wa-button>
		<wa-card appearance="outlined">
			<div class="wa-stack wa-gap-m">
				<div class="wa-stack wa-gap-s">
					<h1 waHeading="xl" waText>WebAwesome Pro</h1>
					<p waBody="m" waText>Premium WebAwesome plugin &mdash; WaPage layout system with 18 sub-components &#40;banner, header, navigation, main, aside, footer, menu, dialog wrappers&#41; for full application shell composition. Includes Angular directive wrappers, slot projection with semantic HTML, and property binding support.</p>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25+</wa-tag>
						<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
						<wa-tag pill variant="neutral">Angular 21</wa-tag>
						<wa-tag pill variant="neutral">TypeScript 5</wa-tag>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>COORDINATES &amp; MODULE</div>
					<p waBody="s" waText>Maven: com.jwebmp.plugins:web-awesome-pro</p>
					<p waBody="s" waText>JPMS Module: com.jwebmp.webawesomepro</p>
					<p waBody="s" waText>Built on: WebAwesome 1.0</p>
				</div>
				<wa-details summary="Installation">
					<div class="wa-stack wa-gap-xs">
						@if (!useGradle) {
							<div class="code-block-wrapper">
								<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Maven</div>
								<markdown [data]="mdContent_693" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
							</div>
						}
						@if (useGradle) {
							<div class="code-block-wrapper">
								<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Gradle &#40;Kotlin DSL&#41;</div>
								<markdown [data]="mdContent_694" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
							</div>
						}
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-m">
					<h2 waHeading="l" waText>Components &#40;7&#41;</h2>
					<p waBody="m" waText>Click any component to see its full API &mdash; properties, constructors, methods, events, slots, and examples.</p>
					<div class="wa-grid wa-gap-s" style="--min-column-size:18rem;">
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>WaPage</h4>
								<p waBody="s" waColorText="quiet" waText>Application shell with 18 sub-components</p>
								<div class="wa-cluster wa-gap-xs"></div>
								<wa-button [routerLink]="['/plugins/web-awesome-pro/wa-page']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>WaBanner</h4>
								<p waBody="s" waColorText="quiet" waText>Top banner area for announcements</p>
								<div class="wa-cluster wa-gap-xs"></div>
								<wa-button [routerLink]="['/plugins/web-awesome-pro/wa-banner']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>WaHeader</h4>
								<p waBody="s" waColorText="quiet" waText>Application header with branding</p>
								<div class="wa-cluster wa-gap-xs"></div>
								<wa-button [routerLink]="['/plugins/web-awesome-pro/wa-header']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>WaNavigation</h4>
								<p waBody="s" waColorText="quiet" waText>Primary navigation container</p>
								<div class="wa-cluster wa-gap-xs"></div>
								<wa-button [routerLink]="['/plugins/web-awesome-pro/wa-navigation']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>WaMain</h4>
								<p waBody="s" waColorText="quiet" waText>Main content area with page size support</p>
								<div class="wa-cluster wa-gap-xs"></div>
								<wa-button [routerLink]="['/plugins/web-awesome-pro/wa-main']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>WaAside</h4>
								<p waBody="s" waColorText="quiet" waText>Side panel for secondary content</p>
								<div class="wa-cluster wa-gap-xs"></div>
								<wa-button [routerLink]="['/plugins/web-awesome-pro/wa-aside']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>WaFooter</h4>
								<p waBody="s" waColorText="quiet" waText>Application footer</p>
								<div class="wa-cluster wa-gap-xs"></div>
								<wa-button [routerLink]="['/plugins/web-awesome-pro/wa-footer']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
					</div>
				</div>
				<wa-details summary="Features (9)">
					<div class="wa-stack wa-gap-xs">
						<p waBody="s" waColorText="quiet" waText>WaPage component with 18 sub-components for full application shell composition</p>
						<p waBody="s" waColorText="quiet" waText>11 layout containers &mdash; Banner, Header, Navigation, Main, Aside, Footer, and more</p>
						<p waBody="s" waColorText="quiet" waText>7 control components &mdash; SkipToContent, Menu, Toggle, DialogWrapper, and more</p>
						<p waBody="s" waColorText="quiet" waText>Angular directive wrappers via angular-awesome library</p>
						<p waBody="s" waColorText="quiet" waText>Slot projection with semantic HTML &#40;18 slots&#41;</p>
						<p waBody="s" waColorText="quiet" waText>Property binding support &#40;12 binding methods&#41;</p>
						<p waBody="s" waColorText="quiet" waText>CRTP fluent API for method chaining</p>
						<p waBody="s" waColorText="quiet" waText>&#64;NgImportReference and &#64;NgImportModule annotation integration</p>
						<p waBody="s" waColorText="quiet" waText>Comprehensive JUnit 5 test suite &#40;13 tests&#41;</p>
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="Examples (1)">
					<div class="wa-stack wa-gap-m">
						<div class="wa-stack wa-gap-xs">
							<h4 waHeading="s" waText>Full Application Shell</h4>
							<p waBody="s" waColorText="quiet" waText>Build a complete application shell with header, navigation, main content, and footer.</p>
							<markdown [data]="mdContent_695" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
						</div>
					</div>
				</wa-details>
				<wa-details open summary="Quick Start">
					<markdown [data]="mdContent_696" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="SPI Extension Point Details (1)">
					<div class="wa-stack wa-gap-s">
						<div class="wa-stack wa-gap-xs">
							<div class="wa-cluster wa-gap-xs">
								<wa-tag pill variant="success">IPageConfigurator</wa-tag>
								<wa-tag pill variant="neutral">provides</wa-tag>
							</div>
							<p waBody="s" waColorText="quiet" waText>Registers WaPage CSS/JS and angular-awesome directives</p>
						</div>
					</div>
				</wa-details>
				<wa-details open summary="SPI Extension Points">
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="success">provides IPageConfigurator</wa-tag>
						</div>
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="Prerequisites">
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25 LTS</wa-tag>
						<wa-tag pill variant="neutral">Maven 3.9+</wa-tag>
						<wa-tag pill variant="neutral">Node.js 18+</wa-tag>
						<wa-tag pill variant="neutral">Angular 21+</wa-tag>
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<div class="wa-cluster wa-gap-s">
					<wa-tag pill variant="neutral">Upstream: https://webawesome.com/</wa-tag>
					<wa-tag pill variant="neutral">Source: https://github.com/JWebMP/WebAwesomePro</wa-tag>
				</div>
			</div>
		</wa-card>
	</div>
</div>